export default __webpack_public_path__ + "static/media/location.642f054d.svg";